import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { createSearchParamBySelectedFilterOption } from '../../utils/filter/createSearchParamBySelectedFilterOption.util';
import { useAppSelector } from '../store/useStore';

// 적용된 필터 옵션이 변경될 때, 이를 Search Param 에  반영하기 위한 hooks
export const useChangeSearchParamBySelectedFilterOption = () => {
  const navigate = useNavigate();

  const productFilterStates = useAppSelector((state) => state.productFilter);

  useEffect(() => {
    // search param 체크가 완료된 이후에 productFilters 가 변경될 때 수행
    if (productFilterStates.isSearchParamChecked && productFilterStates.globalProductFilters) {
      navigate(`/products/list?${createSearchParamBySelectedFilterOption(productFilterStates.globalProductFilters)}`, {
        replace: true,
      });
    }
  }, [productFilterStates.isSearchParamChecked, productFilterStates.globalProductFilters]);
};
